import * as types from './types';

export const toggleSidebar = () => ({
  type: types.TOGGLE_SIDEBAR
});

export const setSidebarVisible = (isVisible) => ({
  type: types.SET_SIDEBAR_VISIBLE,
  payload: isVisible
});

export const setSidebarCollapsed = (isCollapsed) => ({
  type: types.SET_SIDEBAR_COLLAPSED,
  payload: isCollapsed
});

export const updateContext = (context) => ({
  type: types.UPDATE_CONTEXT,
  payload: context
});

export const addMessage = (message) => ({
  type: types.ADD_MESSAGE,
  payload: message
});

export const updateMessage = (messageId, updates) => ({
  type: types.UPDATE_MESSAGE,
  payload: { messageId, updates }
});

export const clearMessages = () => ({
  type: types.CLEAR_MESSAGES
});

export const setConversationId = (conversationId) => ({
  type: types.SET_CONVERSATION_ID,
  payload: conversationId
});

export const setTyping = (isTyping) => ({
  type: types.SET_TYPING,
  payload: isTyping
});

export const setPendingAction = (action) => ({
  type: types.SET_PENDING_ACTION,
  payload: action
});

export const clearPendingAction = () => ({
  type: types.CLEAR_PENDING_ACTION
});

export const sendMessageRequest = () => ({
  type: types.SEND_MESSAGE_REQUEST
});

export const sendMessageSuccess = () => ({
  type: types.SEND_MESSAGE_SUCCESS
});

export const sendMessageFailure = (error) => ({
  type: types.SEND_MESSAGE_FAILURE,
  payload: error
});

export const executeActionRequest = () => ({
  type: types.EXECUTE_ACTION_REQUEST
});

export const executeActionSuccess = () => ({
  type: types.EXECUTE_ACTION_SUCCESS
});

export const executeActionFailure = (error) => ({
  type: types.EXECUTE_ACTION_FAILURE,
  payload: error
});

export const loadConversationRequest = () => ({
  type: types.LOAD_CONVERSATION_REQUEST
});

export const loadConversationSuccess = (conversation) => ({
  type: types.LOAD_CONVERSATION_SUCCESS,
  payload: conversation
});

export const loadConversationFailure = (error) => ({
  type: types.LOAD_CONVERSATION_FAILURE,
  payload: error
});

export const setError = (error) => ({
  type: types.SET_ERROR,
  payload: error
});

export const clearError = () => ({
  type: types.CLEAR_ERROR
});
